export default __webpack_public_path__ + "static/media/map_file_download.d6bec505.svg";